const SECTION_CONFIG = [
  { suffix: '__product_list_YidTcf', variant: 'scale-up-bottom', staggerSelector: '.product-card, .product-grid__item' },
  {
    suffix: '__section_x4Vg7x',
    variant: 'fade',
    staggerSelector: '.group-block-content > *',
    videoSelector: '.section-content-wrapper deferred-media > video',
  },
  { suffix: '__product_list_pKYiPi', variant: 'rise', staggerSelector: '.product-card, .product-grid__item' },
  { suffix: '__hero_UT3CRt', variant: 'zoom', staggerSelector: '.group-block-content > *' },
  { suffix: '__carousel_e8TWm4', variant: 'slide', staggerSelector: '.card' },
];

function initScrollReveal() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const targets = SECTION_CONFIG.flatMap(({ suffix, variant, staggerSelector, videoSelector }) =>
    Array.from(document.querySelectorAll(`div[id$="${suffix}"] .section`)).map((el) => ({
      el,
      variant,
      staggerSelector,
      videoSelector,
    }))
  );

  if (targets.length === 0) return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const target = entry.target;
        target.classList.add('scroll-reveal--visible');

        const staggerSelector = target.dataset.revealStagger;
        if (staggerSelector) {
          const children = target.querySelectorAll(staggerSelector);
          children.forEach((child, index) => {
            child.style.setProperty('--reveal-delay', `${Math.min(index, 8) * 70}ms`);
            child.classList.add('scroll-reveal__item');
          });
          target.classList.add('scroll-reveal--stagger');
        }

        const videoSelector = target.dataset.revealVideo;
        if (videoSelector) {
          const video = target.querySelector(videoSelector);
          if (video) {
            video.classList.remove('x4-video-animate');
            // Restart keyframe animation reliably
            // eslint-disable-next-line no-unused-expressions
            video.offsetWidth;
            video.classList.add('x4-video-animate');
          }
        }

        observer.unobserve(target);
      }
    },
    {
      threshold: 0.18,
      rootMargin: '0px 0px -8% 0px',
    }
  );

  for (const { el, variant, staggerSelector, videoSelector } of targets) {
    el.classList.add('scroll-reveal', `scroll-reveal--${variant}`);
    if (staggerSelector) {
      el.dataset.revealStagger = staggerSelector;
    }
    if (videoSelector) {
      el.dataset.revealVideo = videoSelector;
    }
    observer.observe(el);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initScrollReveal, { once: true });
} else {
  initScrollReveal();
}
